import {Link} from "react-router-dom";

const privacyPolicyUrl = "/documents/privacy_policy.pdf";

export function PrivacyPolicyDocument() {
    return (
        <div className="site-section">
            <div className="container">
                <div className="row justify-content-center text-center">
                    <div className="col-lg-8 text-center mb-4">
                        <h2>Политика обработки персональных данных</h2>
                        <p>Документ по обработке персональных данных.</p>
                        <p>
                            <a href={privacyPolicyUrl} target="_blank" rel="noreferrer">
                                Открыть документ в новой вкладке
                            </a>
                        </p>
                        <div className="privacy-policy-mobile-card">
                            <p>Просмотр в вашей версии браузера недоступен. Откройте документ в отдельной странице по кнопке ниже.</p>
                            <a className="btn btn-primary" href={privacyPolicyUrl} target="_blank" rel="noreferrer">
                                Открыть PDF
                            </a>
                        </div>
                    </div>
                </div>
                <div className="row justify-content-center privacy-policy-frame-wrap">
                    <div className="col-12">
                        <iframe
                            className="privacy-policy-frame"
                            src={privacyPolicyUrl}
                            title="Политика обработки персональных данных"
                        />
                    </div>
                </div>
            </div>
        </div>
    );
}

export default function Information() {
    return (
        <div className="site-section">
            <div className="container">
                <div className="row justify-content-center text-center">
                    <div className="col-lg-8 text-center mb-4">
                        <h2>Информация</h2>
                        <p>Документы, доступные для просмотра на сайте.</p>
                    </div>
                </div>
                <div className="row justify-content-center">
                    <div className="col-lg-8">
                        <div className="list-group">
                            <Link className="list-group-item list-group-item-action" to="/information/privacy-policy">
                                Политика обработки персональных данных
                            </Link>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}
